<template>
    <div class="finish">
        <div class="finish-task">
            <div
                v-for="(item, index) in list"
                :key="index"
                class="task-one finished"
            >
                {{ index + 1 }}.{{ item.nameEn }}
                <div class="box">
                    <i
                        class="icon iconfont icon-duigou"
                        style="color: #fff"
                    ></i>
                </div>
            </div>
            <!-- <div class="task-one finished">
        完成
        <div class="box">
          <i class="icon iconfont icon-duigou" style="color:#fff;"></i>
        </div>
      </div> -->
            <div class="line"></div>
        </div>
        <div class="finish-header">
            <p>Exhibition Application/参展申请</p>
            <span></span>
            <p>Submitted/提交成功</p>
        </div>

        <div class="finish-content">
            <div class="tip">
                <i class="icon iconfont icon-duigou"></i>
            </div>
            <p>
                Your booth application is submitted.
                <br />
                您的展位申请提交成功
            </p>
            <p>
                An email will be sent to you as soon as possible. Please be
                available on your phone！
                <br />
                我们将尽快与您联系，请及时查收邮件并保持电话畅通！
            </p>
            <p>Thank you!/感谢您的申请！</p>
        </div>

        <div class="finish-btn">
            <div>
                <div>
                    <i
                        class="iconfont icon-xiazai3"
                        style="font-size: 50px"
                    ></i>
                </div>
                <Button type="primary" size="large" @click="downloadPdf">
                    Generate & Download
                    <br />
                    生成并下载展位确认函</Button
                >
            </div>
            <!-- <div>
        <div><i class="iconfont icon-zhizhen" style="font-size: 50px"></i></div>
        <Button type="primary" size="large" @click="goApply"
          >申请其他展会</Button>
      </div> -->
            <!-- <div>
        <div><i class="iconfont icon-feiji" style="font-size: 50px"></i></div>
        <Button type="primary" size="large" @click="ruzhu">入驻宝舰平台</Button>
      </div> -->
        </div>
    </div>
</template>

<script>
import config from '@assets/config.json'
import {mapActions} from 'vuex'

export default {
    name: 'finish', // 参展申请 - 完成
    data() {
        return {
            list: [],
        }
    },
    components: {},
    computed: {
        applyCompanyId() {
            return this.$route.query.applyCompanyId
        },
        applyCompanyOrderId() {
            return this.$route.query.applyCompanyOrderId
        },
        groupId() {
            return this.$route.query.termId
        },
    },
    methods: {
        ...mapActions({
            openNewApply: 'openNewApply',
            getApplyFlow: 'getApplyFlow',
        }),
        async goApply() {
            let info = await this.openNewApply({
                ApplyCompanyId: this.applyCompanyId,
            })
            if (info && info.successed) {
                this.$router.push(
                    '/join/pavilion/basicEn?exhibitionId=' +
                        this.exhibitionId +
                        '&termId=' +
                        this.groupId
                )
            } else {
                this.$router.push(
                    '/join/pavilion/basicEn?exhibitionId=' +
                        this.exhibitionId +
                        '&termId=' +
                        this.groupId
                )
            }
        },
        ruzhu() {
            window.open('http://ruzhu.jzzchina.com/#/businessJoin', '_blank')
        },
        downloadPdf() {
            window.open(
                `${config.api.reqApi}/Pdf/Index?orderId=` +
                    this.applyCompanyOrderId,
                '_blank'
            )
        },
        async init() {
            // 流程
            let list = await this.getApplyFlow()
            let arr = []
            list.forEach((e) => {
                if (e.speed !== 2) {
                    arr.push(e)
                }
            })
            this.list = arr
        },
    },
    created() {
        if (!this.applyCompanyId) {
            this.$router.push(
                '/join/pavilion/basicEn?id=' +
                    this.exhibitionId +
                    '&termId=' +
                    this.groupId
            )
        }
        this.init()
    },
}
</script>

<style scoped lang="scss">
.finish {
    &-task {
        width: 100%;
        margin: 20px 0 50px;
        padding: 0 80px;
        display: flex;
        justify-content: space-between;
        color: #666;
        position: relative;
        .task-one {
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 2;
            .box {
                width: 20px;
                height: 20px;
                background-color: #fff;
                box-shadow: 0px 2px 5px 0px rgba(1, 53, 97, 0.5);
                border-radius: 50%;
                margin-top: 10px;
                div {
                    width: 14px;
                    height: 14px;
                    background-color: #8ba5bc;
                    border-radius: 50%;
                    margin: 3px auto 0;
                }
            }
        }
        .line {
            height: 8px;
            background-color: #d7dee4;
            position: absolute;
            width: 998px;
            left: 108px;
            top: 37px;
            z-index: 1;
        }
        .ing {
            color: #024c8b;
            .box {
                div {
                    background-color: #024c8b;
                }
            }
        }
        .finished {
            color: #024c8b;
            .box {
                background-color: #024c8b;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    &-header {
        width: 100%;
        height: 64px;
        background-color: #024c8b;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
            line-height: 64px;
            font-size: 20px;
        }
        span {
            width: 30px;
            height: 1px;
            background-color: #fff;
            margin: 0 15px;
        }
    }

    &-content {
        background-color: #fff;
        padding-top: 100px;
        .tip {
            width: 102px;
            height: 102px;
            border-radius: 50%;
            background-color: #024c8b;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            margin-bottom: 20px;
            i {
                font-size: 100px;
            }
        }
        p {
            text-align: center;
            font-size: 18px;
            margin-top: 10px;
            color: #333;
        }
    }

    &-btn {
        padding-top: 20px;
        padding-bottom: 80px;
        text-align: center;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 150px;
        button {
            width: 200px;
            height: 48px;
            background-color: #024c8b;
            font-size: 16px;
            border-color: #024c8b;
        }
    }
}
</style>
